import { useState, useEffect } from 'react';
import EventEmitter from 'wolfy87-eventemitter';
import supportsWebp from 'supports-webp';

const queue = new EventEmitter();
let globalSupported = null;
let detecting = false;

export const detectWebp = () => {
    if (globalSupported !== null) {
        return Promise.resolve(globalSupported);
    }
    if (detecting) {
        return new Promise((resolve) => {
            queue.once('detected', resolve);
        });
    }
    detecting = true;
    return supportsWebp.then((newSupported) => {
        detecting = false;
        globalSupported = newSupported;
        queue.emit('detected', newSupported);
        return newSupported;
    });
};

const useWebp = ({ timeout = 500 } = {}) => {
    const [supported, setSupported] = useState(globalSupported);
    useEffect(() => {
        let canceled = false;
        let timeoutRef = null;
        if (supported === null) {
            timeoutRef = setTimeout(() => {
                setSupported(false);
                timeoutRef = null;
            }, timeout);
            detectWebp().then((newSupported) => {
                if (timeoutRef !== null) {
                    clearTimeout(timeoutRef);
                    timeoutRef = null;
                }
                if (!canceled) {
                    setSupported(newSupported);
                }
            });
        }
        return () => {
            canceled = true;
            if (timeoutRef !== null) {
                clearTimeout(timeoutRef);
            }
        };
    }, [supported, timeout]);
    return supported;
};

export default useWebp;
